import { render, staticRenderFns } from "./NotionIcon.vue?vue&type=template&id=f9648e40&scoped=true&"
import script from "./NotionIcon.vue?vue&type=script&lang=js&"
export * from "./NotionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9648e40",
  null
  
)

export default component.exports